import {HStack, Text, VStack} from '@chakra-ui/layout';
import {OrderModalIcon} from '@/components/svg/OrderModalIcon';
import NiceModal from '@ebay/nice-modal-react';
import {dateEnTexte} from 'ff-common';
import {ChangerDateDeLivraisonModale} from '@/components/Modale/CalendarModale/ChangerDateDeLivraisonModale';
import {useTranslation} from 'react-i18next';
import {PanierCommands} from 'ff-common/src/hooks/panier/use-panier-commands';
import {RapportMatch} from 'api-types/ffconnect';
import {AlerteMatchingPdf} from './AlerteMatchingPdf';

export const PanierRecapDate: React.FC<{
  date_de_livraison_ou_d_enlevement?: string;
  changerDateCommand: PanierCommands['changerDateDeLivraison'];
  // Panier PDF uniquement : matching de la date extraite du bon de commande.
  matchingDate?: RapportMatch['date_de_livraison'];
}> = ({
  date_de_livraison_ou_d_enlevement,
  changerDateCommand,
  matchingDate,
}) => {
  const {t} = useTranslation();

  // Panier PDF : la date demandée par le client n'a pas pu être retenue telle
  // quelle (passée, ou sans tournée). L'alerte reflète le rapport figé au
  // matching.
  const alerteDate =
    matchingDate && matchingDate.etat !== 'ok' && matchingDate.message
      ? t(`back_office.pdf_order_import.match.${matchingDate.message}`, {
          defaultValue: '',
        })
      : undefined;

  return (
    <VStack
      alignItems='stretch'
      p='5'
      borderRadius='8px'
      bg='blue.bg'
      textColor='blue.main'
    >
      <HStack>
        <OrderModalIcon
          color='blue.main'
          width='18px'
          height='18px'
        />
        <Text fontSize='sm'>{t('mes_informations.date_de_livraison')}</Text>
      </HStack>
      <Text
        fontWeight='700'
        fontSize='md'
      >
        {dateEnTexte(date_de_livraison_ou_d_enlevement)}
      </Text>
      <Text
        textDecorationLine='underline'
        cursor='pointer'
        fontSize='sm'
        onClick={() => {
          NiceModal.show(ChangerDateDeLivraisonModale, {
            submit: changerDateCommand.submitAsync,
          });
        }}
      >
        {t('panier.commander_pour_une_autre_date')}
      </Text>
      {/* Panier PDF uniquement : alerte sur la date du panier */}
      {alerteDate && <AlerteMatchingPdf message={alerteDate} />}
    </VStack>
  );
};
